import { useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { usePinAuth } from "@/hooks/usePinAuth";

const NotFound = () => {
  const location = useLocation();
  const { pinUser, loading } = usePinAuth();

  const protectedPaths = [
    "/dashboard",
    "/weekly",
    "/manager",
    "/profile",
    "/employees",
    "/projects",
    "/weekly-report",
    "/monthly-report",
  ];

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  if (!loading && !pinUser && protectedPaths.some((p) => location.pathname.startsWith(p))) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Page non trouvée</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
};

export default NotFound;
